import { ListData } from '@fi-app/components/items-list/list-data.service';
import { Injector } from '@angular/core';
import { IStatistic2ReportParameter } from '@fi-app/statistic2/statistic2';
import { Statistic2Service } from '@fi-app/statistic2/statistic2.service';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { Statistic2ReportParameterEditDialogComponent } from '@fi-app/statistic2/statistic2-report-parameter-edit/statistic2-report-parameter-edit-dialog/statistic2-report-parameter-edit-dialog.component';
import { LoadingService } from '@fi-app/shared/fi-loading/loading.service';
import { Statistic2ReportType, Statistic2TimePeriod } from '@fi-app/statistic2/statistic2-types';
import { ObjectTypes } from '@fi-shared/types';
import { cloneDeep, FiDateFormatOptions } from '@fi-shared/utils';
import { Statistic2HelperService } from '@fi-app/statistic2/statistic2-helper.service';
import { IItemsListAction } from '@fi-app/components/items-list/items-list';

// TODO: delete when feature is 'Stable done' - https://chainformation.atlassian.net/browse/FI-6957
export class Statistic2ReportParameterListData extends ListData<IStatistic2ReportParameter> {
    private statistic2Service: Statistic2Service;
    private statistic2HelperService: Statistic2HelperService;
    private fiLoadingService: LoadingService;

    constructor(injector: Injector, isLocalSort?: boolean) {
        super(injector, isLocalSort, 'ChangedOn', true);

        this.ObjectType = ObjectTypes.Statistic2;
        this.statistic2Service = injector.get(Statistic2Service);
        this.statistic2HelperService = injector.get(Statistic2HelperService);
        this.fiLoadingService = injector.get(LoadingService);
        this.deleteFunc = (ids, items) => this.statistic2Service.deleteReportParameters(items);

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.name'),
                'Name',
                new ItemsListHeaderProperties('CcmListItem-Name', true, ItemsListElementType.A, {
                    mobileSubText: (data: IStatistic2ReportParameter) => {
                        return this.fiFormatDateService.formatDate(data.ChangedOn, 'date-time');
                    },
                    onClick: ($event, data: IStatistic2ReportParameter) => {
                        $event.stopPropagation();
                        this.statistic2HelperService.openExtendedReportView(data);
                    },
                }),
            ),
        );

        this.addSpanPlainHeader(
            this.appTextService.get('common.type'),
            'ReportType',
            undefined,
            false,
            (data: IStatistic2ReportParameter) => this.statistic2HelperService.getReportTypeText(data.ReportType),
        );

        this.addSpanPlainHeader(
            this.appTextService.get('statistic.for'),
            'ReadRatingFor',
            undefined,
            false,
            (data: IStatistic2ReportParameter) => this.statistic2HelperService.getReportForText(data),
        );

        this.addSpanPlainHeader(
            this.appTextService.get('statistic.results_shown'),
            'Statistic2ResultsPer',
            undefined,
            false,
            (data: IStatistic2ReportParameter) =>
                this.appTextService.get('statistic.per') +
                ' ' +
                this.statistic2HelperService.getShowResultsPerText(data.ShowResultsPerType).toLowerCase(),
        );

        this.addSpanPlainHeader(
            this.appTextService.get('checklist.period'),
            'TimePeriod',
            undefined,
            false,
            (data: IStatistic2ReportParameter) => {
                if (data.ReportType !== Statistic2ReportType.UserLogins) {
                    return '-';
                }
                if (data.TimePeriod === Statistic2TimePeriod.Custom) {
                    return (
                        this.fiFormatDateService.formatDate(data.TimePeriodStartDate, FiDateFormatOptions) +
                        ' - ' +
                        this.fiFormatDateService.formatDate(data.TimePeriodEndDate, FiDateFormatOptions)
                    );
                }
                return this.statistic2HelperService.getTimePeriodText(data.TimePeriod);
            },
        );
        this.addChangedOnHeader();

        const editAction: IItemsListAction<IStatistic2ReportParameter> = {
            title: this.appTextService.get('statistic.edit_report'),
            onClick: (reportParameter: IStatistic2ReportParameter) => {
                this.openEditReportDialog(reportParameter);
            },
        };
        const actions: IItemsListAction<IStatistic2ReportParameter>[] = [editAction];

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.actions'),
                'Actions',
                new ItemsListHeaderProperties(
                    'CcmListItem-Actions CcmList-Column-ShowBreakMobile',
                    false,
                    ItemsListElementType.Actions,
                    { actions: actions },
                ),
            ),
        );

        this.moreMenuMobileItems = [
            {
                title: this.appTextService.get('statistic.delete_report'),
                condition: () => true,
                isDisabled: () => !this.getSelectedItem(),
                onClick: () => {
                    if (this.getSelectedItem()) this.deleteClick();
                },
            },
            {
                title: editAction.title,
                condition: () => true,
                isDisabled: () => !this.getSelectedItem(),
                onClick: ((onClickFn) => {
                    return () => {
                        const item = this.getSelectedItem();
                        if (item) {
                            onClickFn(this.getSelectedItem());
                        }
                    };
                })(editAction.onClick),
            },
        ];
    }

    private getSelectedItem() {
        return this.SelectedItems.length ? this.SelectedItems[0] : null;
    }

    private openEditReportDialog(reportParameter: IStatistic2ReportParameter) {
        this.statistic2HelperService
            .showEditReportDialog(
                'statistic.edit_statistics_report',
                Statistic2ReportParameterEditDialogComponent,
                cloneDeep(reportParameter),
            )
            .onYesButtonClick((editedReportParameter) => {
                editedReportParameter.DataRepresentationTypeView = editedReportParameter.DataRepresentationType;
                this.fiLoadingService.trackPromise(this.statistic2Service.saveReportParameter(editedReportParameter));
            });
    }
}
